import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { teamRoles } from '@/mocks/strategix';

export default function TeamRoles() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Роли в команде"
          title="Кто за что отвечает"
          description="За каждым участком работы закреплён профильный специалист — так проект ведётся системно, а не «одним человеком на всё»."
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {teamRoles.map((role, index) => (
            <Reveal key={role.title} delay={index * 80} className="h-full">
              <article className="h-full flex gap-4 p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <span className="w-12 h-12 flex-none flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                  <i className={`${role.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-950">{role.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{role.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}